<template>
	<div id="PageContent">
		<div class="wrapper-fluid bg-picture-darken small-nav">


			<Navigation />

			<div class="container content-page">

				<div class="row">
					<div class="col-12">
						<div class="wrapper-headlines">
							<div class="row justify-content-center">
								<div class="col-md-12 col-lg-auto">
									<h1 class="d-inline-block" v-html="page.header"></h1>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">


					<div class="col-md-12 col-lg-12 wrapper-rounded-content content-answers">
						<div class="bg-blue-multiply rounded-corners"></div>
						<div class="row justify-content-center headinline">
							<div class="col-md-12">
									 <span v-html="page.content"></span>
 
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageContent',
	data() {
	    return {
	      id: this.$route.params.id,
	      page: {}
	    };
	  },
	  methods: {
	    
	  },
	  mounted() {

	    	var self = this;
	    	var footer = this.$store.getters['orm/footernavigation'](this.$route.params.id);
	    	var main = this.$store.getters['orm/mainnavigation'](this.$route.params.id);

	    	if (footer) {
	    		self.page = footer
	    	}else if(main){
	    		self.page = main
	    	}else{
	    		self.$router.push({ path: '/' })
	    	}
	    	console.log(footer);
	    	console.log(main);

	  },
	   watch: {
	    '$route' (to, from) {
	      var self = this;
	    	var footer = this.$store.getters['orm/footernavigation'](this.$route.params.id);
	    	var main = this.$store.getters['orm/mainnavigation'](this.$route.params.id);

	    	if (footer) {
	    		self.page = footer
	    	}else if(main){
	    		self.page = main
	    	}else{
	    		self.$router.push({ path: '/' })
	    	}
	    }
	  },
}
</script>





// WEBPACK FOOTER //
// src/components/Pages/PageContent.vue